<div *ngIf="!isLoading">
  <header>
    <div class="d-flex flex-column">
      <div class="top-bar d-flex flex-row justify-content-between align-items-center">
          <div class="logo-container pointer">
              <a href="https://knowledgehook.com">
                  <kh-img path="https://staticcontent.knowledgehook.com/content/icons/logos/kh-logo-new-navbar.svg" class="logo"></kh-img>
              </a>
          </div>
      </div>
    </div>
  </header>
  <div class="d-flex flex-column justify-content-center align-items-center info-container text-center">
    <kh-img path="https://staticcontent.knowledgehook.com/content/images/404-image.png" class="glass"></kh-img>
    <h1 class="kh-heading-lg-fluid kh-black header">
      {{ 'PAGE_NOT_FOUND.PAGE_NOT_FOUND' | translate }}
    </h1>
    <p class="kh-lg-main-fluid  kh-black text">
      {{ 'PAGE_NOT_FOUND.OOPS_LOOKS_LIKE_THAT_PAGE' | translate }}
    </p>
    <a href="https://www.knowledgehook.com" *ngIf="!isLoggedIn" class="text-link-secondary text-link-secondary-lg text-link-secondary-md-mob link">
      {{ 'PAGE_NOT_FOUND.GO_TO_KNOWLEDGEHOOKCOM' | translate }}<kh-img path="https://staticcontent.knowledgehook.com/content/icons/directional/friendly/arrow-right.svg" class="chevron"></kh-img>
    </a>
    <a (click)="navigateToHome()" *ngIf="isLoggedIn" class="text-link-secondary text-link-secondary-lg text-link-secondary-md-mob link">
      {{ 'PAGE_NOT_FOUND.BACK_TO_HOME' | translate }}<kh-img path="https://staticcontent.knowledgehook.com/content/icons/directional/friendly/arrow-right.svg" class="chevron"></kh-img>
    </a>
  </div>
</div>
